// extracted by mini-css-extract-plugin
export var skipAnimation = "_18-0";